// extracted by mini-css-extract-plugin
export default {"retailRMN":"retailRMN_retailRMN__cB+zo","container":"retailRMN_container__8qx2r"};